if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
/* Lightbox pinch + double-tap zoom. Listeners live on the lightbox only,
   so normal page scrolling is never blocked. */
(function () {
  function setup(modal) {
    var content = modal.querySelector('.product-media-modal__content');
    if (!content || modal.dataset.zoomReady) return;
    modal.dataset.zoomReady = '1';

    var img = null, scale = 1, tx = 0, ty = 0, start = null, lastTap = 0;

    function dist(t) {
      return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
    }
    function apply() {
      var maxX = (img.clientWidth * (scale - 1)) / 2;
      var maxY = (img.clientHeight * (scale - 1)) / 2;
      tx = Math.max(-maxX, Math.min(maxX, tx));
      ty = Math.max(-maxY, Math.min(maxY, ty));
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }
    function reset() {
      content.querySelectorAll('img').forEach(function (i) {
        i.style.transform = '';
        i.style.transition = '';
      });
      scale = 1; tx = 0; ty = 0; img = null; start = null;
    }

    content.addEventListener('touchstart', function (e) {
      var el = e.target.closest('img');
      if (!el) return;
      if (img && img !== el) reset();
      img = el;
      img.style.transformOrigin = 'center center';
      img.style.transition = 'none';
      if (e.touches.length === 2) {
        start = { d: dist(e.touches), s: scale };
      } else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTap < 300) {
          scale = scale > 1 ? 1 : 2.5;
          tx = 0; ty = 0;
          img.style.transition = 'transform .2s';
          apply();
          lastTap = 0; start = null;
          return;
        }
        lastTap = now;
        start = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: tx, ty: ty };
      }
    }, { passive: true });

    content.addEventListener('touchmove', function (e) {
      if (img && start && e.touches.length === 2 && start.d) {
        scale = Math.max(1, Math.min(4, start.s * (dist(e.touches) / start.d)));
        apply();
      } else if (img && start && e.touches.length === 1 && scale > 1 && start.x !== undefined) {
        tx = start.tx + (e.touches[0].clientX - start.x);
        ty = start.ty + (e.touches[0].clientY - start.y);
        apply();
      }
      e.preventDefault();
    }, { passive: false });

    content.addEventListener('touchend', function (e) {
      if (!img) return;
      if (scale < 1.05) { scale = 1; tx = 0; ty = 0; apply(); }
      if (e.touches.length === 1 && scale > 1) {
        start = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: tx, ty: ty };
      } else if (e.touches.length === 0) {
        start = null;
      }
    }, { passive: true });

    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) reset();
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  document.querySelectorAll('product-modal').forEach(setup);
})();

/* Fit long product titles on two lines (mobile only). */
(function () {
  var h = document.querySelector('product-info .product__title h1');
  if (!h) return;
  var lastWidth = -1;

  function fit() {
    var w = window.innerWidth;
    if (w === lastWidth) return;
    lastWidth = w;
    h.style.removeProperty('font-size');
    if (w > 749) return;

    var cs = getComputedStyle(h);
    var size = parseFloat(cs.fontSize);
    var ratio = parseFloat(cs.lineHeight) / size;
    if (h.scrollHeight <= size * ratio * 2 + 2) return;

    var lo = 13, hi = size;
    h.style.setProperty('font-size', lo + 'px', 'important');
    if (h.scrollHeight > lo * ratio * 2 + 2) return;
    for (var i = 0; i < 4; i++) {
      var mid = (lo + hi) / 2;
      h.style.setProperty('font-size', mid + 'px', 'important');
      if (h.scrollHeight > mid * ratio * 2 + 2) hi = mid; else lo = mid;
    }
    h.style.setProperty('font-size', lo + 'px', 'important');
  }

  fit();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { lastWidth = -1; fit(); });
  }
  window.addEventListener('resize', function () { requestAnimationFrame(fit); });
})();